'use strict';
module.exports = require('./AutoComplete.vue');